// /src/seo.js
const SITE_URL = 'https://kemp3.app';

// Construit une URL canonique propre: base + path optionnel
function canonical(path = '') {
  const base = SITE_URL.replace(/\/+$/, '');
  if (!path) return base;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${base}${clean}`;
}

const defaultTitle = 'KEMP3 — MP3 Tag Editor Pro';
const defaultDescription =
  "KEMP3 est un éditeur de tags MP3 rapide et privé, 100% local dans votre navigateur : modifiez les métadonnées et les pochettes sans aucun upload.";

function webPage({ name = defaultTitle, url = SITE_URL, description = defaultDescription } = {}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    url,
    description,
  };
}

function org() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'KEMP3',
    url: SITE_URL,
    sameAs: ['https://github.com/h1site/kemp3'],
  };
}

export default { SITE_URL, canonical, defaultTitle, defaultDescription, webPage, org };
